import axios from "axios";

//const API = axios.create({
//    baseURL: "http://localhost:3001/api"
//   //LIVE : baseURL: "/api"
//});

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

API.interceptors.request.use((req) => {
    const token = localStorage.getItem("token");
    if (token) {
        req.headers.authorization = token;
    }
    return req;
});

export default API;